import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const StaticGetLinkSection = ({ loadPreviousStaticBuilderSection, documentType }) => {
  const onBackClick = useCallback(() => {
    loadPreviousStaticBuilderSection();
  });

  const onSaveClick = useCallback(() => {
    window._track('Save and Get Link', `${documentType} | Static-builder-member`);
  });

  return (
    <div id="screen" className="static-request-signature-content-section page">
      <h2>
        We&#39;ll create a reusable form with fillable fields from this waiver
        and take you to get a shareable link to your document
      </h2>
      <div className="innerContent">
        <div className="form-actions">
          <button
            className="backButton pull-left btn btn-large"
            onClick={onBackClick}
          >
            Back
          </button>
          <button
            className="pull-right btn btn-large btn-success saveButton"
            onClick={onSaveClick}
          >
            Save & Get Link
          </button>
        </div>
      </div>
    </div>
  );
};

StaticGetLinkSection.defaultProps = {
  documentType: '',
};

StaticGetLinkSection.propTypes = {
  documentType: PropTypes.string,
  loadPreviousStaticBuilderSection: PropTypes.func.isRequired,
};

export default StaticGetLinkSection;



// WEBPACK FOOTER //
// ./src-react/StaticGetLinkSection/index.jsx